export function isPresent(value) {
  return ![null, undefined].includes(value) && value.toString().trim() !== '';
}

export function yesOrNo(value) {
  return value === true ? 'Ja' : 'Nein';
}
